











































import { Component, Vue, Prop } from "vue-property-decorator";
import { GlobalStore } from "@/stores/GlobalStore";
import { RoomConfig } from "@/classes/RoomConfig";
import { STANDARD_CARD_CONFIG } from "@/interfaces/Deck";

@Component({})
export default class NewTableDialog extends Vue {
  @Prop() readonly globalStore!: GlobalStore;
  private name = "";
  private password = "";
  private numberOfSeats = 8;

  createAndJoinRoom() {
    this.globalStore
      .createCardRoom(
        this.name,
        new RoomConfig(STANDARD_CARD_CONFIG, this.numberOfSeats),
        this.password
      )
      .then(key => {
        this.globalStore.joinRoom(key);
      });
  }
}
